import React, { useState } from "react";
import Select from "react-select";

const FilterComponent = ({
  clubs,
  studios,
  setStudios,
  clubId,
  setClubId,
  studioId,
  setStudioId,
  getStudios,
  getSchedules,
  setTypeId,
  setToggleWeek,
  listType,
}) => {
  const [showAlert, setShowAlert] = useState(false);
  const [selectedWeek, setSelectedWeek] = useState("current");
  const [selectedTypeId, setSelectedTypeId] = useState(null);
  const [idHidden, setIdHidden] = useState(["11", "114"]);


  const handleClubChange = async (selectedOption) => {
    const newClubId = selectedOption?.value ? parseInt(selectedOption.value, 10) : "";
    setClubId(newClubId);
    setStudioId("");
    setStudios([]); // Clear studios immediately
    if (newClubId) {
      await getStudios(newClubId);
    }
  };

  const handleStudioChange = (selectedOption) => {
    const newStudioId = selectedOption?.value ? parseInt(selectedOption.value, 10) : "";
    setStudioId(newStudioId);
  };

  const handleTypeChange = (e) => {
    if (!clubId) {
      setShowAlert(true);
    } else {
      setSelectedWeek(e);
      setToggleWeek(e);
    }
  };

  const handleCategoryChange = (e) => {
    if (!clubId) {
      setShowAlert(true);
    } else {
      const value = !e ? null : e;
      setSelectedTypeId(value);
      setTypeId(value);
    }
  };

  // Transform data for React Select
  const clubOptions =
    clubs?.filter((club) => !idHidden.includes(club?.id))?.map((club) => ({
      value: parseInt(club?.id, 10),
      label: club?.name,
    })) || [];

  const studioOptions =
    studios?.map((studio) => ({
      value: parseInt(studio.id, 10),
      label: studio.name,
    })) || [];

  return (
    <div className="row mx-3">
      {showAlert && (
        <div className="alert alert-danger custom-alert" role="alert">
          Please select a club and studio first.
        </div>
      )}
      <div className="col-12 col-md-5 pe-1" style={{ paddingLeft: 0, zIndex: 1000 }}>
        <Select
          className="mb-3"
          classNamePrefix="select"
          value={clubOptions.find((option) => option.value === parseInt(clubId, 10)) || null} 
          onChange={handleClubChange}
          options={clubOptions}
          placeholder="Select Club"
          // isClearable
          isSearchable
        />
      </div>
      <div className="col-12 col-md-5 pe-1" style={{ paddingLeft: 0, zIndex: 100 }}>
        <Select
          className="mb-3"
          classNamePrefix="select"
          value={
            studioOptions.find((option) => option.value === parseInt(studioId, 10)) || null
          }
          onChange={handleStudioChange}
          options={studioOptions}
          placeholder="Select Studio"
          isClearable
          isSearchable
          isDisabled={!studios?.length}
        />
      </div>
      <div className="col-4 col-md-2 d-flex justify-content-md-end px-0 container-button-week">
        <button
          className={`mb-3 btn align-items-center button-this-week ${selectedWeek === "current" && "selected"}`}
          onClick={() => handleTypeChange("current")}
        >
          <span>This week</span>
        </button>
        <button
          className={`mb-3 btn button-next-week ${selectedWeek === "next" && "selected"}`}
          onClick={() => handleTypeChange("next")}
        >
          <span>Next week</span>
        </button>
      </div>

      <div
        className="category-scrollbar d-flex justify-content-start align-items-center flex-nowrap"
      >
        {listType?.map((type, idx) => (
          <div className="me-2" key={idx}>
            <button
              className={`mb-3 btn button-category ${
                (type?.id || null) === selectedTypeId ? "selected" : null
              }`}
              onClick={() => handleCategoryChange(type?.id)}
            >
              {type.id ? (
                <i
                  className="bi bi-bookmark-fill me-2"
                  style={{ color: type?.bg_color }}
                ></i>
              ) : (
                <></>
              )}
              <span>{type?.name}</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterComponent;
